import React from "react";
import { Route, Switch } from "react-router-dom";
import admin from "./admin";

const App = ({ match }) => {
  return (
    <div className="gx-main-content-wrapper" style={{ padding: "0px 32px" }}>
      <Switch>
        <Route path={`${match.url}`} component={admin} />
      </Switch>
    </div>
  );
};

export default App;
